import * as React from 'react';
import styled from 'styled-components';
import {
    TextField,
    Select,
    FormHelperText,
    withStyles,
    Checkbox
} from '@material-ui/core';
import { themeProvider } from '@swipejobs/frontend-theme-provider';
import { LabelPosition } from '@models/field-builder/label-position';

export const CheckboxStyled = withStyles(() => ({
    root: {
        '&$checked': {
            color: themeProvider.getColors().general.primaryColor,
        },
        '&$disabled': {
            color: themeProvider.getColors().general.disabledColor,
        },
    },
    checked: {},
    disabled: {},
}))(Checkbox);

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5%;
  width: 100%;
  height: 100%;
`;

export const SectionBlock = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 12px;
`;

export const Alignment = styled.div<{ labelPosition?: LabelPosition, hidden?: boolean }>`
  display: flex;
  flex-direction: ${props => (props.labelPosition && props.labelPosition === LabelPosition.TOP ? 'column' : 'row')};
  align-items: ${props => (props.labelPosition && props.labelPosition === LabelPosition.TOP ? 'flex-start' : 'center')};
  padding-right: 20px;
  visibility: ${props => props.hidden ? 'hidden' : ''};
`;

export const InputField = styled(TextField) <{ labelPosition?: LabelPosition, width?: string }>`
  margin: 10px;
  width: ${props => (props.width ? props.width : '250px')};
  max-width: 100%;
    & fieldset > legend {
    border: 0;
  }
`;

export const SelectLabel = styled.div<{ paddingBottom?: boolean }>`
  padding-bottom: ${props => (props.paddingBottom ? '8px' : 0)};
  padding-right: 15px;
`;

export const SectionText = styled.p<{ narrow?: boolean; subText?: boolean }>`
  margin-top: ${props => (props.narrow ? 0 : '25px')};
  font-weight: 600;
  color: ${props => (props.subText ?
    () => themeProvider.getColors().general.disabledColor :
    () => themeProvider.getColors().title.defaultColor)};
`;

export const Separator = styled.div<{ style?: string }>`
  width: 100%;
  height: 0;
  border-width: 1px;
  border-style: ${props => props.style ? props.style : 'dashed'};
  border-color: ${() => themeProvider.getColors().border.primaryBorder};
  margin-top: 25px;
  margin-bottom: 25px;
`;

export const PlaceHolder = styled.span`
  color: ${() => themeProvider.getColors().general.disabledColor};
`;

interface CustomisedSelectInputProps {
    maxHeight?: string;
}

type SelectInputProps = React.ComponentProps<typeof Select> & CustomisedSelectInputProps;
export const SelectInput = styled<React.ComponentType<SelectInputProps>>(Select).attrs(props => ({
    // MenuProps: {
    //   PopoverClasses: {
    //     root: 'SelectInputPopoverPaper',
    //     paper: 'SelectInputPopoverPaper',
    //     // classes: {
    //     //   PaperProps: {
    //     //     root: 'SelectInputPopoverPaper'
    //     //   }
    //     // }
    //   }
    // }
}))`
  max-width: 100%;
    & fieldset > legend {
    border: 0;
  }
`;

export const Flex = styled.div`
 ${SectionBlock}{
   flex-direction: column;
 }
`;

export const FlexContainer = styled.div`
 display: flex;
 padding-top: 10px;
 overflow-x: auto;
 min-height: fit-content;
 flex-wrap: wrap;

 ${SectionBlock} {
  flex-direction: column;
  margin-right: 100px;
 }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${() => themeProvider.getColors().border.primaryBorder};
`;

export const ListContainer = styled.div<{ autoWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: ${props => props.autoWidth ? '1 1 auto' : '0 0 250px'};
  margin-right: 5px;
  border: ${() => themeProvider.getFraming().border.tiny};
  border-color: ${() => themeProvider.getColors().border.darkerBorder};
  background-color: ${() => themeProvider.getColors().table.primaryTableColor};
`;

export const ListContainerItem = styled(FlexContainer)<{ isWrap?: boolean, hasBorder?: boolean }>`
 flex-wrap: ${props => props.isWrap ? 'wrap' : 'nowrap'};
 padding: 0;
 
 ${SectionBlock} {
  width: 100%;
  margin: 10px 0;
  border-bottom: ${props => props.hasBorder ? () => themeProvider.getFraming().border.medium : 0};

  & p {
    margin-top: 0;
    min-height: 0;
  }
  
  ${Alignment} {
    justify-content: space-between;
    padding: 0 12px;
  }
  
  ${SelectLabel} {
    padding: 0;
  }
 }
`;

export const HelperTextContainer = styled(FormHelperText)`
  padding-left: 15px;
`;



// WEBPACK FOOTER //
// ./src/components/field-builder/styles.tsx